/* eslint-disable */
// @ts-nocheck

import React from "react";
import { Tile } from "@carbon/react";
import Button, { Icons } from "../buttons/Button";
import { OVERVIEW_TILE_TRANSLATIONS } from "../../translations/util";

interface IProps {
  title: string;
  total: string[];
  Avg: string;
  Max: string;
  Min: string;
  onClick?: any;
  hideStyle?: "";
  disableTop10btn?: boolean;
}

const Tiles = ({
  title,
  total,
  Avg,
  Max,
  Min,
  onClick,
  hideStyle = "",
  disableTop10btn = false,
}: IProps) => {
  return (
    <div className="tile-container">
      <Tile>
        <div className="tile-title-container">
          <h6 className="tile-title">{title}</h6>
          <Button
            label={OVERVIEW_TILE_TRANSLATIONS.btnLabel}
            kind="tertiary"
            className={`${hideStyle ? "hide-top10-btn w-full" : "w-full"}`}
            icon={Icons.Chart}
            onClick={onClick}
            disabled={disableTop10btn}
          ></Button>
        </div>
        <div className="tile-body">
          <div className="tile-total-col">
            <div className="tile-total-header">
              {OVERVIEW_TILE_TRANSLATIONS.labels.total}{" "}
            </div>
            <div className="tile-total-content">{total}</div>
          </div>
          <div className={`inner-col ${hideStyle}`}>
            <div className="tile-avg-header">
              {OVERVIEW_TILE_TRANSLATIONS.labels.avg}{" "}
            </div>
            <div className="tile-avg-content">{Avg}</div>
          </div>
          <div className={`inner-col ${hideStyle}`}>
            <div className="tile-avg-header">
              {OVERVIEW_TILE_TRANSLATIONS.labels.max}{" "}
            </div>
            <div className="tile-avg-content">{Max}</div>
          </div>
          <div className={`inner-col ${hideStyle}`}>
            <div className="tile-avg-header">
              {OVERVIEW_TILE_TRANSLATIONS.labels.min}{" "}
            </div>
            <div className="tile-avg-content">{Min}</div>
          </div>
        </div>
      </Tile>
    </div>
  );
};

export default Tiles;
